module.exports = __webpack_public_path__ + "img/blending-into-right.475c0073.png";